import React from 'react'

function Bottom() {
    return (
        <div>
            <footer class="py-3 my-4">
                
                <p class="text-center text-muted">© 2021 김간장게장. All rights reserved.</p>
        </footer>
        </div>
    )
}

export default Bottom
